import { Stack, styled, Typography, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { Share04Icon } from '@/components/icons/Share04Icon';

import { getTriggerStyling } from './styles';

export type LinkProps = React.PropsWithChildren<{
  display: string;
  external?: boolean;
}> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

const StyledLink = styled('a')<{ color: string; hoverColor: string }>(({
  theme,
  color,
  hoverColor,
}: {
  theme: Theme;
  color: string;
  hoverColor: string;
}) => {
  return {
    ...getTriggerStyling(color, hoverColor, theme),
    // generally hiding text decoration is bad for accessibility, but we're replacing it with an
    // underline in the trigger styling.
    textDecoration: 'none',
  };
});

/**
 * This is a link element that's styled to be identical to the LinkButton.
 */

export function Link({ display, external, ...nativeButtonProps }: LinkProps) {
  const theme = useTheme();
  const color = theme.palette.links.main;
  const hoverColor = theme.palette.links.dark;
  const externalLinkProps = external
    ? {
        target: '_blank',
      }
    : {};
  return (
    <StyledLink
      color={color}
      hoverColor={hoverColor}
      type="button"
      {...nativeButtonProps}
      {...externalLinkProps}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography variant="title-xs" component="span" color="inherit">
          {display}
        </Typography>
        {external && (
          <Share04Icon
            sx={{
              height: 13,
              width: 13,
              display: 'flex',
              alignItems: 'center',
              color: 'inherit',
            }}
          />
        )}
      </Stack>
    </StyledLink>
  );
}
